module.exports = __webpack_public_path__ + "img/03.aedf65f5.png";